import { Tooltip } from "@mui/material";
import { IoMdInformationCircleOutline } from "react-icons/io";

const TooltipIcon = ({ content } : 
    {content: any} 
) => {

    return(

        <Tooltip
            title={content}
            placement="right-start"
            arrow
        >
            <span 
                style={{
                    cursor: "pointer",
                    color: '#777',
                    fontSize: '14px',
                    }}>
                    {IoMdInformationCircleOutline({})}
            </span>
        </Tooltip>
    );
}

export default TooltipIcon;